import React, { memo, useState } from "react"
import { Tooltip, getFormattedRecentDate, useAppContext, Person } from "@dit/core-frontend"
import { Box, Text } from "@mos-cat/ds"

import styles from "./styles.module.css"
import { DateTime } from "luxon"
import { CommentActions } from "./CommentActions"
import { CommentEditComposer } from "./CommentEditComposer"
import { CommentReadComposer } from "./CommentReadComposer"

export const CommentsPanelListComment = memo(({ comment }) => {
  const { user } = useAppContext()
  const [textContent, setTextContent] = useState(comment.text)

  const [iseEdditComment, setIsEditComment] = useState(false)
  return (
    <Box className={`${styles.CommentPlugin_CommentsPanel_List_Comment}`}>
      <Box className={styles.CommentPlugin_CommentsPanel_List_Details}>
        <Box className={styles.CommentPlugin_CommentsPanel_List_Comment_Author}>
          <Person
            person={comment.user}
            gridGap="5px"
            fontSize="fs-14"
            color="gray-80"
            backgroundColor="inherit"
            isProfileLink
            avatarMarginTop="0"
            maxLines={1}
            alignItems="center"
          />

          <Box display="flex" alignItems="center" gridGap="7px" styles={{ cursor: "pointer" }}>
            {!comment.approved && (
              <CommentActions comment={comment} setIsEditComment={setIsEditComment} />
            )}
          </Box>
        </Box>
        <Text fontSize="fs-14" color="gray-40">
          {getFormattedRecentDate(DateTime.fromISO(comment.createdAt))}
        </Text>
      </Box>
      {iseEdditComment ? (
        <CommentEditComposer
          setTextContent={setTextContent}
          commentId={comment.id}
          commentText={textContent}
          commentTextBlockId={comment.textBlockId}
          setIsEditComment={setIsEditComment}
        />
      ) : (
        <Text className={comment.deleted ? styles.CommentPlugin_CommentsPanel_DeletedComment : ""}>
          <CommentReadComposer text={textContent} />
        </Text>
      )}
    </Box>
  )
})

CommentsPanelListComment.displayName = "CommentsPanelListComment"
